'use strict';

/*global app*/
/*global wrrSuccess*/
/*global initialize*/
/*global services*/
/*global removeDiak*/
/*global blockElement*/
/*global unBlockElement*/
/*global invokeCallback*/
/*global createObjectCallBack*/

function ConsolidationService() {
  this.$container = $('body');

  this.init();
}

ConsolidationService.prototype = $.extend({}, {
  constructor: 'ConsolidationService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.open-consolidation', function () {
      _this.openConsolidation();

      return false;
    });

    $('body').on('click', '.consolidation__create-request', function () {
      _this.createRequest($(this));

      return false;
    });

    $('body').on('click', '.consolidation__print-label', function () {
      _this.printLabel($(this));

      return false;
    });

    $('body').on('click', '.consolidation__create-mismatch-picking', function () {
      _this.createMismatchPicking($(this), function () {
        location.reload();
      });

      return false;
    });

    $('body').on('click', '.consolidation__production-finish', function () {
      _this.finishProduction($(this).closest('tr'), $(this).data('consolidation_box_article_rid'));

      return false;
    });

    var searchTimeout = null;
    $('body').on('keyup change', '.consolidation-form-filter__text, .consolidation-form-filter__location', function (e) {
      e = e || window.event;
      var keyCode = e.keyCode || e.which;

      if (keyCode === 13) {
        return;
      }

      clearTimeout(searchTimeout);

      searchTimeout = setTimeout(function () {
        _this.filterInProduction();
      }, 250);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  doOpenConsolidation: function doOpenConsolidation() {
    var _this = this;

    location.href = app.path('consolidation');

    return _this;
  },

  openConsolidation: function openConsolidation() {
    var _this = this;

    services.get('printer-setting').openPrinterSetting(function () {
      _this.doOpenConsolidation();
    });

    return _this;
  },

  getJoinedDeliveryNotes: function getJoinedDeliveryNotes(RID, callback) {
    var _this = this;

    app.getFormation('consolidation:get_joined_delivery_notes', { RID: RID }, function (res) {
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, res.data.list);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  createRequest: function createRequest($btn) {
    var _this = this;

    var consolidationArticleGroupId = $btn.data('consolidation_article_group_id');
    var articleAbbr = $btn.data('article_abbr');
    var articleName = $btn.data('article_name');
    var articleVariant = $btn.data('article_variant');

    app.getFormation('consolidation:create_request', { ConsolidationArticleGroupId: consolidationArticleGroupId, ArticleAbbr: articleAbbr, ArticleName: articleName, ArticleVariant: articleVariant }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.viewSuccessMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printLabel: function printLabel($btn) {
    var _this = this;

    app.getValue({ value: 1 }, function (value) {
      if (value) {
        app.printer.printConsolidationBoxArticle($btn.data('rid'), value);
      }
    });

    return _this;
  },

  doCreateMismatch: function doCreateMismatch(callback) {
    var _this = this;

    var modal = services.get('modal');
    var $form = modal.contentDOM().find('form');

    modal.block();
    $.post($form.attr('action'), $form.serialize(), function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.close(function () {
          invokeCallback(callback);
        });
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  createMismatch: function createMismatch(callback) {
    var _this = this;

    var modal = services.get('modal');
    var $form = modal.contentDOM().find('form');

    if ($form.find('.consolidation-box-items__is-production:checked').length) {
      services.get('input-service').getValue(app.t('consolidation.insert_production_location'), function (val) {
        $form.find('[name$="[ProductionLocation]"]').val(val);

        _this.doCreateMismatch(callback);
      });
    } else {
      _this.doCreateMismatch(callback);
    }

    return _this;
  },

  createMismatchPicking: function createMismatchPicking($btn, callback) {
    var _this = this;

    var consolidationBatchRID = $btn.data('consolidation_batch_rid');
    var consolidationArticleGroupId = $btn.data('consolidation_article_group_id');
    var isFromLocations = $btn.data('is_from_locations');

    var modal = services.get('modal');
    modal.open({
      height: 'auto',
      width: 'md',
      submitCallBack: createObjectCallBack(_this, 'createMismatch', callback),
      enterSubmitCallBack: createObjectCallBack(_this, 'createMismatch', callback),
      form: true,
    });
    modal.block();
    $.get(app.path('consolidation_create_mismatch_picking'), { ConsolidationBatchRID: consolidationBatchRID, ConsolidationArticleGroupId: consolidationArticleGroupId, IsFromLocations: isFromLocations }, function (res) {
      modal.unBlock();

      if (res.msg === 'SUCCESS') {
        modal.content(res.data.html);

        initialize(modal.contentDOM());
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  finishProduction: function finishProduction($row, consolidationBoxArticleRID) {
    var _this = this;

    blockElement(_this.$container);
    app.getFormation('consolidation:finish_production', { ConsolidationBoxArticleRID: consolidationBoxArticleRID }, function (res) {
      unBlockElement(_this.$container);

      if (res.msg === 'SUCCESS') {
        if (res.data.Result === wrrSuccess) {
          $row.remove();

          app.viewSuccessMessage();
        } else {
          app.viewErrorMessage();
        }
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  filterInProduction: function filterInProduction() {
    var _this = this;

    var text = removeDiak($('.consolidation-form-filter__text').val().toLowerCase());
    var location = $('.consolidation-form-filter__location').val();
    var $items = _this.$container.find('.consolidation__production-item');

    if (!text && !location) {
      $items.show();
      return;
    }

    var filter = '';
    if (text) {
      filter += '[data-filter_text*="' + text + '"]';
    }

    if (location) {
      filter += '[data-filter_production_location="' + location + '"]';
    }

    $items.hide();

    _this.$container.find('.consolidation__production-item' + filter).show();

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

